import { render, staticRenderFns } from "./ShowLecturePost.vue?vue&type=template&id=696a4ece&"
import script from "./ShowLecturePost.vue?vue&type=script&lang=js&"
export * from "./ShowLecturePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports